import React from "react";
import { passwordStrength } from "utils/validations";

export function PasswordStrengthMeter({ password }) {
  if (!password) return null;
  const { score, label, color, suggestions } = passwordStrength(password);

  const segments = [1, 2, 3, 4];
  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
        {segments.map((s) => (
          <div
            key={s}
            style={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              background: s <= score ? color : "#e2e8f0",
              transition: "background 0.15s",
            }}
          />
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#64748b" }}>
        <span style={{ color, fontWeight: 600 }}>{label}</span>
        {suggestions.length > 0 && <span>{suggestions[0]}</span>}
      </div>
    </div>
  );
}
